import { gql } from "@apollo/client";

export const INIT_SHIELDS_MULTIPART_MUTATION = gql`
    mutation InitShieldsMultipart($filename: String!, $contentType: String!) {
        initShieldsMultipartUpload(
            filename: $filename
            contentType: $contentType
        ) {
            key
            uploadId
        }
    }
`;

export const INIT_AVATARS_MULTIPART_MUTATION = gql`
    mutation InitAvatarsMultipart($filename: String!, $contentType: String!) {
        initAvatarsMultipartUpload(
            filename: $filename
            contentType: $contentType
        ) {
            key
            uploadId
        }
    }
`;

export const INIT_HYPE_PRIZES_MULTIPART_MUTATION = gql`
    mutation InitHypePrizesMultipart(
        $filename: String!
        $contentType: String!
    ) {
        initHypePrizesMultipartUpload(
            filename: $filename
            contentType: $contentType
        ) {
            key
            uploadId
        }
    }
`;

export const SIGN_UPLOAD_PART_MUTATION = gql`
    mutation SignUploadPart(
        $key: String!
        $uploadId: String!
        $partNumber: Int!
    ) {
        signUploadPart(
            key: $key
            uploadId: $uploadId
            partNumber: $partNumber
        ) {
            url
        }
    }
`;

export const COMPLETE_MULTIPART_MUTATION = gql`
    mutation CompleteMultipart(
        $key: String!
        $uploadId: String!
        $parts: GenericScalar!
    ) {
        completeMultipartUpload(key: $key, uploadId: $uploadId, parts: $parts) {
            ok
        }
    }
`;

export const START_PROCESS_MUTATION = gql`
    mutation StartProcess($key: String!) {
        startProcessUploadedZip(key: $key) {
            taskId
        }
    }
`;

export const START_PROCESS_AVATARS_MUTATION = gql`
    mutation StartProcessAvatars($key: String!) {
        startProcessPlayerAvatarsZip(key: $key) {
            taskId
        }
    }
`;

export const START_PROCESS_HYPE_PRIZES_MUTATION = gql`
    mutation StartProcessHypePrizes($key: String!, $deleteExisting: Boolean) {
        startProcessHypePrizesExcel(
            key: $key
            deleteExisting: $deleteExisting
        ) {
            taskId
        }
    }
`;

export const INIT_WALLHALLA_MULTIPART_MUTATION = gql`
    mutation InitWallhallaMultipart($filename: String!, $contentType: String!) {
        initWallhallaMultipartUpload(
            filename: $filename
            contentType: $contentType
        ) {
            key
            uploadId
        }
    }
`;

export const START_PROCESS_WALLHALLA_MUTATION = gql`
    mutation StartProcessWallhalla($keys: [String!]!) {
        startProcessWallhalla(keys: $keys) {
            taskId
        }
    }
`;

export const ACTIVATE_WALLHALLA_MANIFEST_MUTATION = gql`
    mutation ActivateWallhallaManifest($manifestId: String!) {
        activateWallhallaManifest(manifestId: $manifestId) {
            ok
            version
        }
    }
`;
